<template>
  <svg :class="svgClass" class="card-panel-icon">
    <use :xlink:href="`#${icon}`" />
  </svg>
</template>

<script>
export default {
	name: 'SvgIcon',
	props: {
		icon: {
			type: String,
			required: true,
		},
		spin: {
			type: Boolean,
			default: false,
		},
	},
  computed: {
    svgClass() {
      if (this.className) {
        return 'svg-icon ' + this.className
      } else {
        return 'svg-icon'
      }
    },
  }
}
</script>

<style>
  .svg-icon {
    width: 1em;
    height: 1em;
    vertical-align: -0.15em;
    fill: currentColor;
    overflow: hidden;
  }
  .svg-external-icon {
    background-color: currentColor;
    mask-size: cover!important;
    display: inline-block;
  }

  .card-panel-icon {
    float: left;
    font-size: 48px;
  }
</style>
